import EntityModel from '@/common/models/entity-model';

export default class OrderReactivationModel extends EntityModel {
    hydrate({
        subscriptionId = null,
        description = null,
        renewalTime = null,
    } = {}) {
        this.subscriptionId = subscriptionId;
        this.description = description;
        this.renewalTime = renewalTime;
    }

    getPayload() {
        return {
            subscriptionId: this.subscriptionId,
            description: this.description,
            renewalTime: this.renewalTime,
        };
    }
}
